module.exports = __webpack_public_path__ + "img/logo2.d6d4f289.png";